import { action } from '../../../appLogic/appActions';

export const CHECKOUT_PRODUCTS = action('CHECKOUT_PRODUCTS');
export const ADD_ORDER_DETAILS = action('ADD_ORDER_DETAILS');
export const CHANGE_PAYMENT_METHOD = 'CHANGE_PAYMENT_METHOD';
